import { Checkbox, Tooltip } from "@mui/material";
import "./dataMapTable.scss";

const isDisabled = (parameterData) => {
  if (parameterData?.validatorRowRejection?.isRejected) {
    return true;
  } else {
    const isRejectedWithinCell = parameterData.mappings.find(
      (ele) => ele?.validatorCellRejection?.isRejected
    );
    if (isRejectedWithinCell) {
      return true;
    } else return false;
  }
};

const ValidationButton = ({
  onClickValidate,
  parameterData,
  parameterIndex,
}) => {
  return (
    <>
      <div className="sub-row validator">
        {parameterData?.rowValidation?.isValidated ? (
          <div
          // className="validator-edit"
          >
            <Tooltip
              arrow
              title={`Validated On :${parameterData?.rowValidation?.date}`}
              placement="top"
            >
              <Checkbox
                checked={true}
                onChange={(e) => onClickValidate("invalidate", parameterIndex)}
                size="small"
                sx={{
                  "&.Mui-checked": {
                    color: "#4caf50",
                  },
                }}
              />

              {/* <input
                type="checkbox"
                checked={true}
                onChange={(e) => onClickValidate("invalidate", parameterIndex)}
              /> */}
            </Tooltip>
          </div>
        ) : (
          <div className="checkbox-wrap ">
            <Checkbox
              onChange={(e) => onClickValidate("validate", parameterIndex)}
              disabled={isDisabled(parameterData)}
              size="small"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ValidationButton;
